<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                :label="label"
                :prepend-icon="prependIcon"
                readonly
                v-bind="attrs"
                v-on="on"
            >
                <template #append v-if="$scopedSlots.append">
                    <slot name="append" />
                </template>
            </v-text-field>
        </template>
        <v-date-picker
            ref="picker"
            v-model="date"
            locale="sv"
            first-day-of-week="1"
            locale-first-day-of-year="4"
            :min="min"
            :max="max"
            @change="save"
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'zoezi-date-field',

    props: ['value', 'label', 'prependIcon', 'min', 'max'],

    data: () => ({
        date: null,
        menu: false,
    }),
    watch: {
        value: {
            handler() {
                this.date = this.value;
            },
            immediate: true,
        },
        menu (val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
    },
    methods: {
        save (date) {
            this.$emit('input', date);
            this.menu = false;
        },
    }
}
</script>
